import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=90e02bde"
import script from "./profession.vue?vue&type=script&lang=js"
export * from "./profession.vue?vue&type=script&lang=js"
import style0 from "./profession.vue?vue&type=style&index=0&id=90e02bde&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports